import { render } from "./SurveyFreeText.vue?vue&type=template&id=34b632c6&scoped=true"
import script from "./SurveyFreeText.vue?vue&type=script&lang=js"
export * from "./SurveyFreeText.vue?vue&type=script&lang=js"

import "./SurveyFreeText.vue?vue&type=style&index=0&id=34b632c6&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b632c6"]])

export default __exports__